export const API_URL = 'https://api.stnimmerlein.com'

export const BASE_TITLE = 'Marco Sieben'

export const COMPONENT_TYPES = ['Paragraph', 'Image'] as const
